import { useState, useCallback } from 'react';

/**
 * Central helper for gating save-style actions behind auth.
 *
 * Usage:
 *   const { requireSignIn, signInModal } = useSignInGate(user);
 *   const onFavorite = () => {
 *     if (requireSignIn('favorite this reflection')) return;
 *     // ...proceed with the actual API call
 *   };
 *   return (<>{signInModal}...</>);
 */
import SignInRequiredModal from '@/components/SignInRequiredModal';
import React from 'react';

export function useSignInGate(user) {
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState('');

  const requireSignIn = useCallback((actionLabel = '') => {
    if (user?.is_guest) {
      setAction(actionLabel);
      setOpen(true);
      return true; // caller should short-circuit
    }
    return false;
  }, [user]);

  const signInModal = (
    <SignInRequiredModal
      open={open}
      onClose={() => setOpen(false)}
      action={action}
    />
  );

  return { requireSignIn, signInModal };
}
